<template>
    <HeaderBar v-if="!appData.isMobile">
        <template #default>
            <li><router-link :to="Links.Url(Links.User.Message)" class="dropdown-item"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect width="20" height="16" x="2" y="4" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>Mesajlarım</router-link></li>
        </template>
        <template #rule>Eğitmen</template>
    </HeaderBar>
    <HeaderBarMobile v-else>
        <slot></slot>
    </HeaderBarMobile>
</template>
<script>
    import HeaderBar from "@/layouts/_partials/HeaderBar.vue";
    import HeaderBarMobile from "@/layouts/_partials/HeaderBar.mobile.vue";

    export default {
        components: {
            HeaderBar,
            HeaderBarMobile,
        },
    };
</script>